import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const referralDetailsKey = "referralDetails";

export const useReferralLink = () => {
  const [searchParams] = useSearchParams();

  const setReferralDetails = useCallback((value) => {
    localStorage.setItem(referralDetailsKey, JSON.stringify(value));
  }, []);

  const getReferralDetails = useCallback(() => {
    const currentReferralDetails = localStorage.getItem(referralDetailsKey);
    const referralDetails = currentReferralDetails
      ? JSON.parse(currentReferralDetails)
      : undefined;

    if (typeof referralDetails === "object") {
      return referralDetails;
    }
    return {};
  }, []);

  const init = useCallback(() => {
    const linkId = searchParams.get("lid");
    const partnerId = searchParams.get("pid");

    if (linkId && partnerId) {
      setReferralDetails({
        linkId: parseInt(linkId),
        partnerId: parseInt(partnerId),
      });
    }
  }, [searchParams, setReferralDetails]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    getReferralDetails,
  };
};
